import styled from 'styled-components';

import { bgColor } from '../../modules/colors';
import media from '../../modules/media';
import { spacing } from '../../modules/metrics';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  min-height: 600px;
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${bgColor};
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: ${spacing.xl}px;
  margin: 0 ${spacing.xl}px;
  max-width: 1440px;
  width: 100%;

  ${media.desktop} {
    flex-direction: column;
    justify-content: flex-start;
  }

  ${media.phone} {
    margin: 0;
    padding: ${spacing.xl}px ${spacing.lg}px;
  }
`;
